var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.8998,
    cy: 20.7682,
    r: 19.5544,
    stroke: "#F36F2E",
    strokeWidth: 1.44848
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4263 15.6985C24.5011 15.6954 23.5844 15.8746 22.7286 16.2261C21.8728 16.5776 21.0947 17.0944 20.4389 17.7469C19.783 18.3994 19.2622 19.1748 18.9064 20.0288C18.5505 20.8827 18.3665 21.7985 18.3649 22.7236V29.8212C18.3649 30.1093 18.4794 30.3856 18.6831 30.5894C18.8868 30.7931 19.1632 30.9075 19.4513 30.9075H21.9861C22.2742 30.9075 22.5506 30.7931 22.7543 30.5894C22.958 30.3856 23.0725 30.1093 23.0725 29.8212V22.7236C23.0722 22.3946 23.1414 22.0692 23.2753 21.7687C23.4093 21.4681 23.605 21.1992 23.8499 20.9794C24.0948 20.7596 24.3832 20.5938 24.6964 20.493C25.0096 20.3921 25.3406 20.3584 25.6677 20.394C26.2543 20.4679 26.7934 20.7545 27.1828 21.1995C27.5722 21.6445 27.7847 22.2169 27.78 22.8081V29.8212C27.78 30.1093 27.8945 30.3856 28.0982 30.5894C28.302 30.7931 28.5783 30.9075 28.8664 30.9075H31.4012C31.6894 30.9075 31.9657 30.7931 32.1694 30.5894C32.3731 30.3856 32.4876 30.1093 32.4876 29.8212V22.7236C32.486 21.7985 32.302 20.8827 31.9461 20.0288C31.5903 19.1748 31.0695 18.3994 30.4136 17.7469C29.7578 17.0944 28.9797 16.5776 28.1239 16.2261C27.2681 15.8746 26.3514 15.6954 25.4263 15.6985Z",
    fill: "#F36F2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1059 16.7849H11.8468C11.2468 16.7849 10.7604 17.2713 10.7604 17.8713V29.8212C10.7604 30.4212 11.2468 30.9076 11.8468 30.9076H15.1059C15.7058 30.9076 16.1922 30.4212 16.1922 29.8212V17.8713C16.1922 17.2713 15.7058 16.7849 15.1059 16.7849Z",
    fill: "#F36F2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4763 14.6122C14.9763 14.6122 16.1922 13.3963 16.1922 11.8963C16.1922 10.3964 14.9763 9.18042 13.4763 9.18042C11.9764 9.18042 10.7604 10.3964 10.7604 11.8963C10.7604 13.3963 11.9764 14.6122 13.4763 14.6122Z",
    fill: "#F36F2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.1087d66efd4a25f82d0b2a05f1ecd705.svg";
export { ForwardRef as ReactComponent };